import { useEffect } from 'react'
import { CLIENT_PORTAL_LABEL, TEAM_PORTAL_LABEL, isFirmBrandedPublicPath, isTeamPath } from '../lib/portalAudience'
import { PORTAL_BRAND_STATUS } from '../components/PortalBrand/portalBrandStatus'

const PUBLIC_URL = process.env.PUBLIC_URL || ''

export const LEGACY_IDENTITY = { title: 'My Debt Lawyers', icon: `${PUBLIC_URL}/favicon.ico` }

const NEUTRAL_ICON = `${PUBLIC_URL}/portal-icon.ico`

const SIGNING_SUCCESS_PATH = '/success/signing'

const portalIdentityFor = ({ status, brand }) => {
  if (status === PORTAL_BRAND_STATUS.FIRM) return { title: brand.name, icon: NEUTRAL_ICON }
  if (status === PORTAL_BRAND_STATUS.LEGACY) return LEGACY_IDENTITY
  return { title: CLIENT_PORTAL_LABEL, icon: NEUTRAL_ICON }
}

export const documentIdentityFor = ({ settled, neutral, preAuth, pathname, portalBrand, staffBrand, signingBrand }) => {
  if (!preAuth && portalBrand) return portalIdentityFor(portalBrand)
  if (!preAuth && staffBrand?.firmIdentity && staffBrand.name) return { title: staffBrand.name, icon: NEUTRAL_ICON }
  if (signingBrand && pathname === SIGNING_SUCCESS_PATH) return { title: signingBrand.name || CLIENT_PORTAL_LABEL, icon: NEUTRAL_ICON }
  if (!preAuth || isFirmBrandedPublicPath(pathname)) return LEGACY_IDENTITY
  if (!settled) return null
  if (!neutral) return LEGACY_IDENTITY
  return { title: isTeamPath(pathname) ? TEAM_PORTAL_LABEL : CLIENT_PORTAL_LABEL, icon: NEUTRAL_ICON }
}

const useDocumentIdentity = (input) => {
  const identity = documentIdentityFor(input)
  const title = identity?.title
  const icon = identity?.icon

  useEffect(() => {
    if (!title) return
    document.title = title
    const link = document.querySelector('link[rel="icon"]')
    if (link) link.setAttribute('href', icon)
  }, [title, icon])
}

export default useDocumentIdentity
